import React from 'react';
import { Circle, Path, Svg } from 'react-native-svg';
import { Stack } from 'tamagui';

import { BacklightPattern } from '../../../hooks/firmware/useBacklight';

interface BacklightPatternIconProps {
  pattern: BacklightPattern;
  size?: number;
  color?: string;
}

export const BacklightPatternIcon: React.FC<BacklightPatternIconProps> = ({
  pattern,
  size = 24,
  color = '#FFFFFF',
}) => {
  const renderIcon = () => {
    switch (pattern) {
      case 'Solid':
        // Solid light icon
        return (
          <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <Circle cx="12" cy="12" r="8" fill={color} />
            <Path
              d="M12 3V5M12 19V21M5 12H3M21 12H19M6.36 6.36L4.93 4.93M19.07 4.93L17.64 6.36M17.64 17.64L19.07 19.07M4.93 19.07L6.36 17.64"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </Svg>
        );
      case 'Off':
        // Light off icon
        return (
          <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <Circle cx="12" cy="12" r="8" stroke={color} strokeWidth="2" />
            <Path
              d="M4 4L20 20"
              stroke={color}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </Svg>
        );
      case 'Slow Pulse':
        // Pulsing light icon
        return (
          <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <Circle cx="12" cy="12" r="6" fill={color} fillOpacity="0.7" />
            <Circle cx="12" cy="12" r="10" stroke={color} strokeWidth="1" strokeOpacity="0.5" />
            <Circle cx="12" cy="12" r="14" stroke={color} strokeWidth="1" strokeOpacity="0.3" />
          </Svg>
        );
      default:
        return null;
    }
  };

  return (
    <Stack width={size} height={size} justifyContent="center" alignItems="center">
      {renderIcon()}
    </Stack>
  );
};
